import React from 'react'
import { Sidebar, ToastProvider } from 'lib/ui'
import Header from 'lib/sections/Header'
import Footer from 'lib/sections/Footer'

const App = ({ Component, pageProps }) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false)

  return (
    <>
      <ToastProvider placement="top-right" autoDismiss>
        <Header
          sidebarOpen={sidebarOpen}
          sidebarOnHide={() => setSidebarOpen(false)}
          sidebarToggle={() => setSidebarOpen(true)}
        />
        <Sidebar.Pushable className="bg-white">
          <Sidebar.Pusher dimmed={sidebarOpen} className="mt-[60px]">
            <Component {...pageProps} />
            <Footer />
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </ToastProvider>
    </>
  )
}

export default App
